export { default } from './ReferralDetail';
